import Button from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import React from "react";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import { useLocalization } from "utilities/hooks/use-localization";
import { useMobileSecondaryNavContent } from "utilities/contexts/use-mobile-secondary-nav/use-mobile-secondary-nav-content";
import { useBookviewSearchContext } from "utilities/contexts/bookview-tab-panel/bookview-search-provider";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface MobileSecondaryNavHeaderProps {
    numberOfShareItems: number;
    userReferencesCount: number;
    closeModal: () => void;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const CSS_CLASS_NAME = "c-mobile-secondary-nav-header";

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const MobileSecondaryNavHeader: React.FC<MobileSecondaryNavHeaderProps> = ({
    numberOfShareItems,
    userReferencesCount,
    closeModal,
}) => {
    const { t } = useLocalization();

    const {
        toggleSecondaryNavModal,
        isRefModalOpen,
        isUserPreferenceModalOpen,
        isShareSpaceModalOpen,
        isSecondaryNavModalOpen,
        isBookviewSearchPanelOpen,
        handleClose,
    } = useMobileSecondaryNavContent();

    const { isSearchCollapsed, setIsSearchCollapsed } =
        useBookviewSearchContext();

    const closeSearchPanel = () => {
        handleClose();
        closeModal();
    };

    const handleMenuClick = () => {
        if (isSearchCollapsed) setIsSearchCollapsed(false);
        toggleSecondaryNavModal();
    };

    if (isSecondaryNavModalOpen) return null;

    return (
        <div
            className={`${CSS_CLASS_NAME}${isBookviewSearchPanelOpen ? " -search" : ""}`}>
            <div className={`${CSS_CLASS_NAME}__breadcrumbs`}>
                <Button
                    onClick={handleMenuClick}
                    style={ButtonStyles.AnchorBlue}
                    cssClassName={`${CSS_CLASS_NAME}__button`}>
                    {t("book-menu")}
                </Button>
                <Icon type={Icons.ChevronRight} size={IconSizes.Small} />
                {isShareSpaceModalOpen && (
                    <span className={`${CSS_CLASS_NAME}__location`}>
                        {t("sharing")} ({numberOfShareItems})
                    </span>
                )}
                {isRefModalOpen && (
                    <span className={`${CSS_CLASS_NAME}__location`}>
                        {t("reference_plural")} ({userReferencesCount})
                    </span>
                )}
                {isUserPreferenceModalOpen && (
                    <span className={`${CSS_CLASS_NAME}__location`}>
                        {t("preferences")}
                    </span>
                )}
                {isBookviewSearchPanelOpen && (
                    <span className={`${CSS_CLASS_NAME}__location`}>
                        {t("search")}
                    </span>
                )}
            </div>

            {isBookviewSearchPanelOpen && (
                <Button
                    onClick={closeSearchPanel}
                    style={ButtonStyles.Text}
                    cssClassName={`${CSS_CLASS_NAME}__close-button`}
                    accessibleText={t("close")}>
                    <Icon type={Icons.Close} size={IconSizes.Medium} />
                </Button>
            )}
        </div>
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default MobileSecondaryNavHeader;

// #endregion Exports
